import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { usePRD3031_R01Store } from "src/containers/mes/PRD/PRD3031_R01/Store_PRD3031_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_PRD3031_R01 } from "./Content_PRD3031_R01";
import { SearchSection_PRD3031_R01 } from "./SearchSection_PRD3031_R01";
import { Table_PRD3031_R01 } from "./Table_PRD3031_R01";
import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { PRD3031_R01GridRowData } from "./Dto_PRD3031_R01";

/**
 * 생산 실적 관리 컨테이너 컴포넌트
 * 생산 실적 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_PRD3031_R01 = () => {
    const { initData } = usePRD3031_R01Store();
    const { setMessage } = useUiuxStore();
    const gridRef = useRef<AgGridReact<PRD3031_R01GridRowData>>(null);

    const {
        fetchData,
        handleExcelClick,
    } = Content_PRD3031_R01({
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined} // TODO: 저장 기능 구현 예정
                onDeleteClick={() => {}}
                onInitClick={initData}
                onExcelClick={handleExcelClick}
            />
            
            <SearchSection_PRD3031_R01 />
            
            <div className="flex flex-1 p-[12px] min-h-0">
                <div className="h-full w-full">
                    <Table_PRD3031_R01 gridRef={gridRef} />
                </div>
            </div>
            
            <Message />
        </div>
    );
};
